module.exports = __webpack_public_path__ + "static/media/Ravi.c7ad4ed0.png";